var _defs, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#005833;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Elipse_8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m272.51172,503.69434c-29.32617.00195-58.6416-5.77832-86.55176-17.33887-55.81348-23.11914-99.2832-66.58887-122.40234-122.40234-23.11865-55.81348-23.11865-117.28906,0-173.10254s66.58887-99.2832,122.40234-122.40234h0c55.81299-23.11816,117.28857-23.11816,173.10254,0,55.81396,23.11914,99.28369,66.58887,122.40234,122.40234s23.11865,117.28906,0,173.10254-66.58887,99.2832-122.40234,122.40234c-27.90332,11.55859-57.23242,17.33789-86.55078,17.33887ZM189.4043,76.7627C78.77197,122.58887,26.04736,249.87695,71.87256,360.50977c45.82568,110.63184,173.1123,163.35352,283.74561,117.53125,110.63232-45.82617,163.35693-173.11426,117.53174-283.74707-45.8252-110.63184-173.11377-163.35352-283.74561-117.53125h0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_992",
    className: "cls-1",
    d: "m322.23015,239.49396h-33.71208v-21.91249c-.6371-4.91193,2.82901-9.41017,7.74154-10.04666.50703-.06564,1.02008-.08792,1.53193-.06624h23.59918v-37.07642h-32.87386c-37.07703,0-44.65357,27.81199-44.65357,44.66321v24.43801h-21.03272v37.92489h21.07366v107.01647h44.65357v-107.01586h30.3375l3.33484-37.92489Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.696cd77d4e98b14ae5160031a28f44a1.svg";
export { ForwardRef as ReactComponent };